import { noop } from 'es-toolkit';
export class PromiseWithResolver extends Promise {
    resolve = noop;
}
